export default __webpack_public_path__ + "static/media/6.bec6b252.jpg";